module.exports = __webpack_public_path__ + "static/media/blueDownloadIcon.72520495.svg";